import type React from "react";
import {Handle, type NodeProps, Position} from "@xyflow/react";
import {Stack, Typography} from "@mui/material";
import {CurrencyComponent} from "~/components/currency-component/CurrencyComponent";
import {MONO_FONT} from "~/style/fonts";
import type {FocusNode} from "~/pages/supplier-360/tabs/SupplierValueChain/components/chain/valueChainLayout";

export const FOCUS_ACCENT = '#5D4CC8';

const HIDDEN_HANDLE: React.CSSProperties = {opacity: 0, pointerEvents: 'none'};

export const ChainFocusNode: React.FC<NodeProps<FocusNode>> = ({data}) => {
    const {entity} = data;
    const country = entity.se_country?.code_a2;

    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            gap={0.25}
            sx={{
                height: '100%',
                px: 2,
                border: `1.5px solid ${FOCUS_ACCENT}`,
                borderRadius: '14px',
                background: 'linear-gradient(#F7F5FF, #FFFFFF)',
            }}
        >
            <Handle type="target" position={Position.Left} isConnectable={false} style={HIDDEN_HANDLE}/>
            <Typography sx={{font: `700 10px ${MONO_FONT}`, color: FOCUS_ACCENT}}>Focus</Typography>
            <Typography fontSize={19} fontWeight={600} textAlign="center" noWrap maxWidth="100%">
                {entity.canonical_name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
                <CurrencyComponent v={entity.spend}/>{country ? ` · ${country}` : ''}
            </Typography>
            <Handle type="source" position={Position.Right} isConnectable={false} style={HIDDEN_HANDLE}/>
        </Stack>
    );
};
